/**
 * Browser polyfills for Node.js globals
 *
 * Some libraries (like @openauthjs/openauth) expect Node.js globals
 * to be available in the browser environment.
 */

// Polyfill process global
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).process = {
    env: {},
    version: '',
    versions: {},
    browser: true,
    platform: 'browser',
    nextTick: (fn: () => void) => setTimeout(fn, 0),
  };

  // Also set global to window
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).global = window;
}

export {};
